import { NONE_SELECTED, UNLABELED, UNLABELED_FILTER_SENTINEL } from '@/features/datasets/components/DataSelection/RawRecordsStatus/constants';

const ORIGIN_LABELS_COLUMN_RE = /^(?:extra_param_)?(origin_labels\d*)$/;

function firstValue(values) {
    return Array.isArray(values) ? values[0] : values;
}

/** Column name from a string or `{ key, is_multilabel }` origin-labels filter. */
export function originLabelsFilterKey(value) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
        return value.key || value.origin_key || null;
    }
    return value || null;
}

export function originLabelsFilterPayload(key, isMultilabel = false) {
    return { key, is_multilabel: Boolean(isMultilabel) };
}

function originLabelsApiValue(values) {
    const origin = firstValue(values);
    const key = originLabelsFilterKey(origin);
    if (!key) return null;
    if (origin && typeof origin === 'object' && !Array.isArray(origin)) {
        return originLabelsFilterPayload(key, origin.is_multilabel);
    }
    return key;
}

/**
 * Map Data Editor / Improve modal `currentFilters` onto the dataset-records
 * query shape. `record_ids` becomes `_id` (`$in` on the server). Origin-label
 * match/mismatch filters stay scalars or `{ key, is_multilabel }`. `view_label`
 * is UI-only.
 */
export function formatFiltersForAPI(filters = {}) {
    const formattedFilters = {};

    if (filters.is_in_dataset !== undefined) {
        formattedFilters.is_in_dataset = filters.is_in_dataset;
    }

    Object.entries(filters).forEach(([key, values]) => {
        if (key === 'is_in_dataset' || key === 'view_label') return;

        if (key === 'record_ids') {
            if (Array.isArray(values)) {
                formattedFilters._id = values;
            }
            return;
        }

        if (key === 'origin_labels_mismatch' || key === 'origin_labels_match') {
            const originFilter = originLabelsApiValue(values);
            if (originFilter) {
                formattedFilters[key] = originFilter;
            }
            return;
        }

        const originColumn = typeof key === 'string' ? key.match(ORIGIN_LABELS_COLUMN_RE) : null;
        if (originColumn) {
            const mode = firstValue(values);
            const originKey = originColumn[1];
            if (mode === 'mismatch') {
                formattedFilters.origin_labels_mismatch = originKey;
            } else if (mode === 'match') {
                formattedFilters.origin_labels_match = originKey;
            }
            return;
        }

        if (!(values && values.length > 0)) return;

        if (key === 'score') {
            const scoreFilter = values[0];
            if (scoreFilter === 'validated') {
                formattedFilters.is_validated = true;
            } else if (scoreFilter === 'excellent') {
                formattedFilters.min_score = 70;
            } else if (scoreFilter === 'good') {
                formattedFilters.min_score = 50;
                formattedFilters.max_score = 70;
            } else if (scoreFilter === 'poor') {
                formattedFilters.max_score = 50;
            }
        } else if (key === 'display_name') {
            formattedFilters.display_name = values[0];
        } else if (key === 'labels') {
            if (Array.isArray(values) && values.includes(UNLABELED)) {
                formattedFilters.labels = [UNLABELED_FILTER_SENTINEL];
            } else if (Array.isArray(values) && values.includes(NONE_SELECTED)) {
                formattedFilters.labels = [''];
            } else {
                formattedFilters.labels = values;
            }
        } else if (key === 'review_status') {
            formattedFilters.review_status = firstValue(values);
        } else if (key === 'entities' || key === 'relations') {
            formattedFilters[key] = values;
        } else {
            formattedFilters[key] = values;
        }
    });

    return formattedFilters;
}
